import { connect } from 'react-redux';
import { getProperty } from '../../api/property/propertyAction';
import { getCity } from '../../api/cityes/cityesAction';
import { getWebsiteAppearance } from '../../api/websiteAppearance/websiteAppearanceAction';
import { sortCitiesByName } from '../../utils/sortCities';
import AppChrome from './app-chrome.component';

const mapDispatchToProps = {
  getProperty,
  getCity,
  getWebsiteAppearance,
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.customerPage.isLoggedIn,
  loggedCustomer: state.customerPage.loggedCustomer,
  isSaved: state.customerPage.isSaved,
  cities: sortCitiesByName(state.cityPage.cities),
  properties: state.propertyPage.properties,
  websiteAppearance: state.websiteAppearancePage.appearance,
});

export default connect(mapStateToProps, mapDispatchToProps)(AppChrome);
